module.exports = __webpack_public_path__ + "static/media/AB_P7_10.a4b93973.jpg";